import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResources } from '@constants/api-resources';
import { BaseLocalRepository } from '@data/base/base-local.repository';
import { ClienteEntity, CodigoClienteEntity } from '@domain/dto/cliente/cliente-get.dto';
import { ClientePostDto } from '@domain/dto/cliente/cliente-post.dto';
import { map, Observable } from 'rxjs';
import { PersonMapper } from './person.mapper';

@Injectable()
export class PersonRepository extends BaseLocalRepository {
  private mapper = new PersonMapper();
  constructor(httpClient: HttpClient) {
    super(httpClient, ApiResources.CLIENTS_PASSAPORT);
  }

  getById(id: any, type: string): Observable<ClienteEntity> {
    this.basePath = type == 'cpf' ? ApiResources.CLIENTS_CPF : ApiResources.CLIENTS_PASSAPORT;
    return this.getByIdRequest(id).pipe(
      map((item) => {
        if (Array.isArray(item) && item[0]) {
          return this.mapper.fromJson(item[0]);
        }
        this.basePath = ApiResources.CLIENTS;
        return item;
      })
    );
  }

  getByCpfOrPass(id: any, type: string): Observable<CodigoClienteEntity> {
    this.basePath = ApiResources.CLIENTES_CODIGO;
    let param = {};

    if (type == 'cpf') {
      param = { cpf: id };
    } else if (type == 'passaporte') {
      param = { passaporte: id };
    } else if (type == 'rg') {
      param = { rg: id };
    } else {
      param = { numeroCNH: id }
    }

    return this.getRequest(param);
  }

  insert(param: ClientePostDto): Observable<ClientePostDto> {
    this.basePath = ApiResources.CLIENTS;
    return this.postRequest<ClientePostDto>(param);
  }

  update(param: ClientePostDto): Observable<ClientePostDto> {
    return this.putRequest(param.CodigoCliente, param);
  }
}
